//--------------------------------------------------------------

export enum ModalsEnums {
    WALLET_CONNECT = 'Wallet Connect',
    PROCESSING_TASK = 'ProcessingTask',
    PROCESSING_TX = 'ProcessingTx',
    CONFIRM_TX = 'ConfirmTx',
}

export enum TaskEnums {
    CREATE_PROTOCOL = 'CreateProtocol',
    DELETE_PROTOCOL = 'DeleteProtocol',
    SYNC_PROTOCOL = 'SyncProtocol',
    ADD_TEST_TOKENS = 'AddTestTokens',
}

//--------------------------------------------------------------

export enum HandlesEnums {}

//--------------------------------------------------------------
